import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { selectUserRolePermissions } from '@socialive/common';
import { useJoinBroadcastHandler } from '~/hooks';
import { ModalTypes, Pathnames } from '../../helpers/enums';
import { broadcastItemShape } from '../../helpers/propTypeShapes';
import CustomModal from '../CustomModal';
import MoreOptions from './MoreOptions';

export default function BroadcastItem({ APIBaseURL, broadcast, reloadBroadcasts, trackEvent }) {
  const { pathname } = useLocation();
  const { canNavigateInPortal } = useSelector(selectUserRolePermissions);
  const { name, hash, id, user, createdAt, remoteStream, comments } = broadcast;
  const [handleJoinBroadcast, isIncompatibleBrowser, closeModal] = useJoinBroadcastHandler({
    hash,
    trackEvent,
    host: user,
  });
  const dateTime = moment(createdAt).format('MMM DD, YYYY h:mma');

  let description = `Produced by ${user.name} • Created ${dateTime} • ${remoteStream.name}`;

  if (canNavigateInPortal) {
    description =
      pathname === Pathnames.DASHBOARD
        ? `Channel: ${remoteStream.name} • Created ${dateTime}`
        : `Hosted by ${user.name} • Created ${dateTime}`;
  }

  const joinButtonText = canNavigateInPortal && pathname === Pathnames.DASHBOARD ? 'Enter Studio' : 'Join';

  return (
    <div className="broadcast-list-item">
      <div className="broadcast-list-item-info">
        <button
          type="button"
          className="broadcast-list-item-title"
          data-broadcast-hash={hash}
          onClick={handleJoinBroadcast}
        >
          {name}
        </button>
        <div className="broadcast-list-item-desc">{description}</div>
      </div>
      <MoreOptions
        APIBaseURL={APIBaseURL}
        broadcastHash={hash}
        broadcastID={id}
        broadcastTitle={name}
        hasComments={comments}
        reloadBroadcasts={reloadBroadcasts}
        token={remoteStream.token}
      />
      <button type="button" className="broadcast-join-button" data-broadcast-hash={hash} onClick={handleJoinBroadcast}>
        {joinButtonText}
      </button>
      <CustomModal
        handleOnClose={closeModal}
        includeButtons={false}
        isOpen={isIncompatibleBrowser}
        type={ModalTypes.INCOMPATIBLE_BROWSER}
      />
    </div>
  );
}

BroadcastItem.propTypes = {
  APIBaseURL: PropTypes.string.isRequired,
  broadcast: broadcastItemShape.isRequired,
  reloadBroadcasts: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};
